// import { useState, useEffect } from "react";
// import { db } from "../../firebase";
// import {
//   doc,
//   getDocs,
//   collection,
//   setDoc,
//   serverTimestamp,
// } from "firebase/firestore";

// const AddPromoCode = () => {
//   const [code, setCode] = useState("");
//   const [discount, setDiscount] = useState(0);
//   const [isSingleUse, setIsSingleUse] = useState(false);
//   const [appliesType, setAppliesType] = useState("series");
//   const [selectedValues, setSelectedValues] = useState([]);
//   const [expiresFrom, setExpiresFrom] = useState("");
//   const [expiresTo, setExpiresTo] = useState("");
//   const [description, setDescription] = useState("");
//   const [products, setProducts] = useState([]);

//   const seriesList = [
//     "Я граюся, я вчуся",
//     "Вімельбух",
//     "Відкривай (енциклопедії і пізнавальні)",
//     "Найкраще — дітям",
//     "Казкова допомога",
//     "Книжка іграшка",
//     "Малювальна історія",
//     "Рекомендуємо прочитати",
//     "Книга нового року",
//     "Батькам",
//     "Дитячий путівник",
//     "2000 вправ та завдань",
//     "Цікаво",
//     "Святкові",
//     "Посібник",
//     "Розумний календар",
//     "Комікс-книжка",
//     "3000 вправ та завдань",
//     "Know how",
//     "Перше кохання",
//     "Книжка-іграшка",
//     "Класика",
//     "Діточкам",
//   ];

//   useEffect(() => {
//     const fetchProducts = async () => {
//       const snapshot = await getDocs(collection(db, "product"));
//       const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setProducts(list);
//     };
//     fetchProducts();
//   }, []);

//   const toggleValue = (value) => {
//     if (selectedValues.includes(value)) {
//       setSelectedValues(selectedValues.filter((v) => v !== value));
//     } else {
//       setSelectedValues([...selectedValues, value]);
//     }
//   };

//   const handleSubmit = async () => {
//     if (!code || !discount || !expiresTo)
//       return alert("Заповніть усі обов'язкові поля");
//     const promoRef = doc(db, "promo", code);
//     await setDoc(promoRef, {
//       code,
//       discount: Number(discount),
//       isSingleUse,
//       appliesTo: {
//         type: appliesType,
//         values: selectedValues,
//       },
//       expiresFrom: expiresFrom ? new Date(expiresFrom).toISOString() : null,
//       expiresAt: new Date(expiresTo).toISOString(),
//       usedBy: [],
//       isActive: true,
//       createdAt: serverTimestamp(),
//       description,
//     });
//     alert("Промокод додано");
//     setCode("");
//     setDiscount(0);
//     setSelectedValues([]);
//     setExpiresFrom("");
//     setExpiresTo("");
//     setDescription("");
//   };

//   return (
//     <div style={{ padding: 20 }}>
//       <h2>Додати промокод</h2>
//       <input
//         placeholder="Промокод"
//         value={code}
//         onChange={(e) => setCode(e.target.value)}
//       />
//       <br />
//       <input
//         type="number"
//         placeholder="Знижка %"
//         value={discount}
//         onChange={(e) => setDiscount(e.target.value)}
//       />
//       <br />
//       <textarea
//         placeholder="Опис"
//         value={description}
//         onChange={(e) => setDescription(e.target.value)}
//       />
//       <br />
//       <label>
//         <input
//           type="checkbox"
//           checked={isSingleUse}
//           onChange={(e) => setIsSingleUse(e.target.checked)}
//         />{" "}
//         Одноразовий
//       </label>
//       <br />
//       <label>Застосовується до:</label>
//       <select
//         value={appliesType}
//         onChange={(e) => setAppliesType(e.target.value)}
//       >
//         <option value="series">Серій</option>
//         <option value="products">Товарів</option>
//       </select>
//       <div style={{ marginTop: 10 }}>
//         {appliesType === "series" &&
//           seriesList.map((ser, i) => (
//             <label key={i}>
//               <input
//                 type="checkbox"
//                 value={ser}
//                 checked={selectedValues.includes(ser)}
//                 onChange={() => toggleValue(ser)}
//               />{" "}
//               {ser}
//             </label>
//           ))}
//         {appliesType === "products" &&
//           products.map((p, i) => (
//             <label key={i}>
//               <input
//                 type="checkbox"
//                 value={p.id}
//                 checked={selectedValues.includes(p.id)}
//                 onChange={() => toggleValue(p.id)}
//               />{" "}
//               {p.bookName || p.name}
//             </label>
//           ))}
//       </div>
//       <div>
//         <label>Дата початку дії (не обов’язково):</label>
//         <input
//           type="date"
//           value={expiresFrom}
//           onChange={(e) => setExpiresFrom(e.target.value)}
//         />
//         <br />
//         <label>Дата завершення дії:</label>
//         <input
//           type="date"
//           value={expiresTo}
//           onChange={(e) => setExpiresTo(e.target.value)}
//         />
//         <br />
//       </div>
//       <button onClick={handleSubmit}>Зберегти</button>
//     </div>
//   );
// };

// export default AddPromoCode;
import { useState, useEffect } from "react";
import { db } from "../../firebase";
import {
  doc,
  getDocs,
  collection,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";

const AddPromoCode = ({ onClose }) => {
  const [code, setCode] = useState("");
  const [discount, setDiscount] = useState("");
  const [isSingleUse, setIsSingleUse] = useState(false);

  const [selectedSeries, setSelectedSeries] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedAuthors, setSelectedAuthors] = useState([]);

  const [expiresFrom, setExpiresFrom] = useState("");
  const [expiresTo, setExpiresTo] = useState("");
  const [description, setDescription] = useState("");

  const [products, setProducts] = useState([]);
  const [authors, setAuthors] = useState([]);

  const seriesList = [
    "Я граюся, я вчуся",
    "Вімельбух",
    "Відкривай (енциклопедії і пізнавальні)",
    "Найкраще — дітям",
    "Казкова допомога",
    "Книжка іграшка",
    "Малювальна історія",
    "Рекомендуємо прочитати",
    "Книга нового року",
    "Батькам",
    "Дитячий путівник",
    "2000 вправ та завдань",
    "Цікаво",
    "Святкові",
    "Посібник",
    "Розумний календар",
    "Комікс-книжка",
    "3000 вправ та завдань",
    "Know how",
    "Перше кохання",
    "Книжка-іграшка",
    "Класика",
    "Діточкам",
  ];

  useEffect(() => {
    const fetchProducts = async () => {
      const snapshot = await getDocs(collection(db, "product"));
      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setProducts(list);
    };

    const fetchAuthors = async () => {
      const snapshot = await getDocs(collection(db, "author"));
      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setAuthors(list);
    };

    fetchProducts();
    fetchAuthors();
  }, []);

  const toggleValue = (value, list, setter) => {
    if (list.includes(value)) {
      setter(list.filter((v) => v !== value));
    } else {
      setter([...list, value]);
    }
  };

  const handleSubmit = async () => {
    if (!code || !discount || !expiresTo) {
      alert("Заповніть усі обов'язкові поля");
      return;
    }

    const promoRef = doc(db, "promo", code);

    const appliesTo = {
      series: selectedSeries,
      products: selectedProducts,
      authors: selectedAuthors,
    };

    await setDoc(promoRef, {
      code,
      discount: Number(discount),
      isSingleUse,
      appliesTo: appliesTo,
      expiresFrom: expiresFrom ? new Date(expiresFrom).toISOString() : null,
      expiresAt: new Date(expiresTo).toISOString(),
      usedBy: [],
      isActive: true,
      createdAt: serverTimestamp(),
      description,
    });

    alert("Промокод додано");
    onClose();
  };

  return (
    <div style={styles.formWrap}>
      <h2>Додати промокод</h2>

      <div style={styles.row}>
        <input
          style={styles.input}
          placeholder="Промокод"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <button
          style={styles.button}
          onClick={() => setCode(uuidv4().slice(0, 8).toUpperCase())}
        >
          Генерувати
        </button>
      </div>

      <input
        type="number"
        placeholder="Знижка %"
        style={styles.input}
        value={discount}
        onChange={(e) => setDiscount(e.target.value)}
      />

      <textarea
        placeholder="Опис"
        style={styles.textarea}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <label>
        <input
          type="checkbox"
          checked={isSingleUse}
          onChange={(e) => setIsSingleUse(e.target.checked)}
        />{" "}
        Одноразовий
      </label>

      <h4>Застосовується до серій:</h4>
      <div style={styles.checkGrid}>
        {seriesList.map((ser) => (
          <label key={ser} style={styles.checkbox}>
            <input
              type="checkbox"
              checked={selectedSeries.includes(ser)}
              onChange={() =>
                toggleValue(ser, selectedSeries, setSelectedSeries)
              }
            />{" "}
            {ser}
          </label>
        ))}
      </div>

      <h4>Застосовується до книг:</h4>
      <div style={styles.checkGrid}>
        {products.map((p) => (
          <label key={p.id} style={styles.checkbox}>
            <input
              type="checkbox"
              checked={selectedProducts.includes(p.id)}
              onChange={() =>
                toggleValue(p.id, selectedProducts, setSelectedProducts)
              }
            />{" "}
            {p.bookName || p.name}
          </label>
        ))}
      </div>

      <h4>Застосовується до авторів:</h4>
      <div style={styles.checkGrid}>
        {authors.map((a) => (
          <label key={a.id} style={styles.checkbox}>
            <input
              type="checkbox"
              checked={selectedAuthors.includes(a.name)}
              onChange={() =>
                toggleValue(a.name, selectedAuthors, setSelectedAuthors)
              }
            />{" "}
            {a.name}
          </label>
        ))}
      </div>

      <div>
        <label>Дата початку дії (не обов’язково):</label>
        <input
          type="date"
          value={expiresFrom}
          onChange={(e) => setExpiresFrom(e.target.value)}
        />
      </div>
      <div>
        <label>Дата завершення дії:</label>
        <input
          type="date"
          value={expiresTo}
          onChange={(e) => setExpiresTo(e.target.value)}
        />
      </div>

      <div style={styles.actions}>
        <button style={styles.button} onClick={handleSubmit}>
          Зберегти
        </button>
        <button style={styles.buttonCancel} onClick={onClose}>
          Скасувати
        </button>
      </div>
    </div>
  );
};

const styles = {
  formWrap: {
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    maxWidth: "700px",
    margin: "20px auto",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    fontFamily: "Arial, sans-serif",
  },
  row: {
    display: "flex",
    marginBottom: "10px",
  },
  input: {
    flex: "1",
    padding: "10px",
    marginRight: "10px",
  },
  textarea: {
    width: "100%",
    padding: "10px",
    minHeight: "60px",
    marginBottom: "10px",
  },
  button: {
    padding: "10px 15px",
    cursor: "pointer",
  },
  buttonCancel: {
    padding: "10px 15px",
    cursor: "pointer",
    background: "#eee",
    marginLeft: "10px",
  },
  checkGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
    gap: "8px",
    margin: "10px 0",
  },
  checkbox: {
    display: "flex",
    alignItems: "center",
  },
  actions: {
    marginTop: "20px",
  },
};

export default AddPromoCode;
